<div id="pageloader" class="row m0">
    <div class="loader-item"><img src="../assets/images/loader_icon.png" class="fa fa-spin" alt="loading"></div>
</div>
<app-navbar></app-navbar>
<router-outlet (activate)="onActive()"></router-outlet>
<app-footer></app-footer>

<div class="whatsapp-icon">
    <a href="https://wa.me/966599454045" class="ico-out" target="_blank"></a>
    <span id="simple-chat-button--text">{{'iconContact' | translate}}</span>
</div>